import { CSSProperties } from 'react';

interface HorizontalLayoutProps {
  children?: any;
  className?: string;
  style?: CSSProperties;
}

const HorizontalLayout = ({ children, className, style }: HorizontalLayoutProps) => {
  return (
    <div className={`flex flex-row ${className}`} style={style}>
      {children}
    </div>
  );
};

export default HorizontalLayout;
